
import { ResultData } from "@nt-portal/common-sdk";

import { TCMDefaultField, TCMDefaultFieldService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { ValidateResult } from "@nt-portal/common-sdk";

export const mappingTypes = ["group-item", "schedule-item", "supplier", "status", "response"]

export interface TCMDefaultFieldOptions extends ControllerOptions<TCMDefaultField> {
    hide?: boolean;
}

export const createTCMDefaultField = (obj: Partial<TCMDefaultField>) => {
    let item: TCMDefaultField = {
        excelHeading: obj.excelHeading || "",
        name: obj.name || "",
        required: obj.required ?? false,
        dataType: obj.dataType || "string",
        order: obj.order ?? 0,
        createdBy: obj.createdBy || "",
        mappingType: obj.mappingType || "group-item",
        hideInGrid: false,
        hideInTemplate: false,
        displayType: obj.displayType || "string",
        width: obj.width ?? 100
    }
    return item;
}

export class ClientTCMDefaultFieldService extends BaseClientService implements DataController<TCMDefaultField> {

    private _service: TCMDefaultFieldService;


    constructor() {
        super();
        this._service = new TCMDefaultFieldService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }



    public async get(options: TCMDefaultFieldOptions): Promise<ResultData<TCMDefaultField>> {
        return await this._service.get(this.buildFetchParams(options), this.token, options.filter, options.hide);
    }

    public async getLookup(options: TCMDefaultFieldOptions): Promise<ResultData<TCMDefaultField>> {

        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token, options.filter, options.hide);
        return data;

    }

    public async getById(options: TCMDefaultFieldOptions): Promise<TCMDefaultField | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMDefaultFieldOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMDefaultFieldOptions): Promise<TCMDefaultField | TCMDefaultField[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMDefaultFieldOptions): Promise<TCMDefaultField | TCMDefaultField[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult> {

        return await this._service.validateName(name, this.token, id)

    }

    public async import(options: TCMDefaultFieldOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMDefaultFieldOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

}